/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import app from 'new-ui/app';
import { useTranslation } from 'utils/modifiedTranslation';
import './TreatmentQuestion.css';
import Button from 'new-ui/Components/Button';
import HCPSelect from 'new-ui/Components/HCP/Select';
import { TREATMENT_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';
import { randomString } from 'new-ui/functions';
import { THEMES } from 'new-ui/constants';
import InfoNote from 'new-ui/Components/InfoNote';
import classNames from 'classnames';
import { INTAKE_GA } from 'modules/ga/intakeEvents';
import { QUESTION_TYPE } from '../../constants';
import { QuestionTitle } from '../../QuestionTitle';

export const getCleanedTreatments = (treatments)=>{
  return treatments?.filter((treatment) => treatment.drugs_received?.length);
};

const getInitialTreatment = (treatments=[]) => {
  return treatments.filter(item => item.drugs_received === null)
};

const hasReceivedDrugs = (treatments) => (treatments ?? []).some((item) => item.drugs_received?.length > 0);

const sendGoogleAnalyticEventByType = (type) => {
  const questionTypes = {
    cycles: INTAKE_GA.events.treatment_q_cycles_answered,
    treatment_stop_reason: INTAKE_GA.events.treatment_q_reason_answered,
  };

  if (questionTypes[type]) {
    app.sendGoogleAnalyticsEvent(INTAKE_GA.category, questionTypes[type]);
  }
};

const scrollToLastItem = () => {
  const container = document.querySelector('.question-renderer');
  if (!container) {
    return;
  }
  const allQuestions = container.querySelectorAll('.treatment-question');
  const lastItem = allQuestions[allQuestions.length - 1];
  if (lastItem) {
    lastItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const TreatmentQuestion = (props) => {
  const { q, onselect, user } = props;
  const { t } = useTranslation();

  /* eslint-disable-next-line */
  const [treatments, setTreatments] = useState(user?.condition_profile?.treatments?.filter(item => item.drugs_received !== null) || []);
  const [isSaveVisible, setSaveVisible] = useState(true);

  const drugsReceived = q.subQuestions.find((sq)=>sq.id === 'drugs_received');

  const treatmentFor = TREATMENT_QUESTION_ID_BY_DISEASE[user.personal.condition];

  useEffect(()=>{
    addTreatment();
    // eslint-disable-next-line
  }, []);

  const newTreatment = ()=>{
    return {
      drugs_received: null,
      treatment_admin: null,
      treatment_end_date: null,
      treatment_stop_reason: null,
    };
  };

  const addTreatment = ()=>{
    const _newTreatment = newTreatment();
    treatments.push(_newTreatment);
    const newTreatments = [...treatments];
    setTreatments(newTreatments);

    if(treatments?.length > 1) {
      setTimeout(() => {
        scrollToLastItem();
      }, 0);
    }
  };

  const handleTreatmentSelect = (v, currentUser, treatment, treatmentList) => {
    if (!hasReceivedDrugs(currentUser.condition_profile.treatments)) {
      app.sendGoogleAnalyticsEvent(
        INTAKE_GA.category,
        INTAKE_GA.events.treatment_q_treatment_answered,
      );
    }
    const previousDrugs = treatment.drugs_received || [];
    treatment.drugs_received = v;
    currentUser.condition_profile.treatments = treatmentList;
    setTreatments([...treatmentList]);
    onselect(getCleanedTreatments(treatmentList), true);
    if (v.length > previousDrugs.length) {
      app.sendGoogleAnalyticsEvent(
        INTAKE_GA.category,
        INTAKE_GA.events.treatment_q_drug_added,
      );
    }
    if (v.length > 1 && (v.length > previousDrugs.length)) {
      app.sendGoogleAnalyticsEvent(
        INTAKE_GA.category,
        INTAKE_GA.events.treatment_q_combination_added,
      );
    }
  };

  const TreatmentSubQuestion = (subQuestion, treatment, idx, user)=>{
    return (
      <div key={randomString()} className="box-question-treatment-section">
        <div className="box-question-treatment-title">
          {t(subQuestion.title)}
        </div>
        <div className="box-question-treatment-select">
          <HCPSelect
            user={user}
            showAutofill={false}
            options={subQuestion.options?.map((b)=>{
              return {
                ...b,
                label: t(b.label),
              };
            })}
            renderOnSelect={false}
            initValue={
              treatments[idx][subQuestion.id]
            }
            onselect={(newValue)=>{
              treatment[subQuestion.id] = newValue;
              // !!! user mutation
              user.condition_profile.treatments = treatments;
              onselect(getCleanedTreatments(treatments), true);
              sendGoogleAnalyticEventByType(subQuestion.id);
            }}
          />
        </div>
      </div>
    );
  };

  const DISABLED_QUESTIONS = [
    'drugs_received',
  ];

  const getSubQuestions = ()=>{
    return q.subQuestions.filter((sq)=>{
      if (sq.type !== QUESTION_TYPE.SINGLE_OPTION_SELECT) {
        return false;
      }
      if (sq.isShown === false) {
        // DEV-3814 Questions for internal usage should not be shown
        return false;
      }
      if (DISABLED_QUESTIONS.includes(sq.id)) return false;
      return true;
    });
  };

  const TreatmentQuestion = ({treatment, idx})=>{
    return (
        <div className="treatment-question">
          <QuestionTitle q={{
            title: !idx ? t('treatment_question.title') : (treatment.isLast && !treatment.drugs_received?.length) ? t('treatment_question.add_treatment') : `${t('general.other_treatment')} ${idx}`,
            subtitle: !idx ? t('treatment_question.subtitle') : t('treatment_question.treatment_drugs'),
          }} />
          {
            <div className="treatment-question-content">
            <div className="treatment-question-drugs-received">
                <div className="treatment-question-drugs-received-select">
                    <HCPSelect
                        defaultOpen={false}
                        user={user}
                        isMulti
                        useTags
                        renderOnSelect={false}
                        initValue={
                            treatment.drugs_received
                        }
                        options={drugsReceived.options.map((o)=>{
                          return {
                            label: t(o.label),
                            value: o.value,
                          };
                        })}
                        onselect={(v) => {
                          handleTreatmentSelect(v, user, treatment, treatments);
                        }}
                    />
                </div>
              {
                treatments[idx]?.drugs_received?.length > 1 ? (
                  <InfoNote info={t('intake.note_description')} />
                ) : null
              }
                {
            !idx && !treatment.drugs_received?.length ? (
                <div className="treatment-question-drugs-received-not-received" onClick={()=>{
                  // !!! user mutation
                    user.condition_profile[treatmentFor] = 'no';
                    user.condition_profile.treatments = [];
                    onselect(getCleanedTreatments(treatments), true);
                    setTreatments(getInitialTreatment(treatments));
                    app.sendGoogleAnalyticsEvent(INTAKE_GA.category, INTAKE_GA.events.treatment_q_not_received_clicked);
                }}>
                    <div className={classNames("treatment-question-drugs-received-not-received-radio", {
                        selected: user.condition_profile[treatmentFor] === 'no'
                    })}>
                        <div className='received-not-received-radio-circle'></div>
                    </div>
                    <div className="treatment-question-drugs-received-not-received-text">{t('treatment_question.not_received')}</div>
                </div>
                ) : null
                }
            </div>
            <div className="treatment-question-treatment-subquestions">
                {
                treatment.drugs_received?.length
                    ? getSubQuestions().map((sq)=>{
                        return TreatmentSubQuestion(sq, treatment, idx, user);
                    })
                    : null
                }
            </div>
          </div>
          }
        </div>
      );

  };

  return <>
    {
      treatments.map((treatment, idx)=>{
        treatment.isLast = false;
        if(treatments[treatments.length-1] === treatment) treatment.isLast = true;
        return <TreatmentQuestion key={idx} treatment={treatment} idx={idx} />
      })
    }
    <div>
        {
          ((treatments.length > 1 || (treatments.length === 1 && treatments[0]?.drugs_received?.length)) && treatments[treatments.length - 1]?.drugs_received?.length) ? (
            !isSaveVisible ? (
              <Button
                className='treatment-question-add-treatment'
                title={t('treatment_question.add_treatment')}
                theme={THEMES.ORANGE_TRANSPARENT}
                action={() => {
                  addTreatment();
                  setSaveVisible(true);
                }}
              />
            ) : (
              <Button
                title={t('general.save')}
                theme={THEMES.DEFAULT}
                action={() => {
                  setSaveVisible(false);
                }}
              />
            )
          ) : null
        }
        <Button className='treatment-question-next' title={t('general.next')} theme={THEMES.ORANGE_FULL} action={()=>{
            onselect(getCleanedTreatments(treatments));
            app.sendGoogleAnalyticsEvent(INTAKE_GA.category, INTAKE_GA.events.treatment_q_next_clicked);
        }} />
    </div>
</>;

};

TreatmentQuestion.propTypes = {
  q: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    options: PropTypes.array,
  }),
  onselect: PropTypes.func,
  user: PropTypes.object.isRequired,
};

export default TreatmentQuestion;
